import { render, staticRenderFns } from "./OaIcon.vue?vue&type=template&id=0bcc6a09&scoped=true"
import script from "./OaIcon.vue?vue&type=script&lang=js"
export * from "./OaIcon.vue?vue&type=script&lang=js"
import style0 from "./OaIcon.vue?vue&type=style&index=0&id=0bcc6a09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc6a09",
  null
  
)

export default component.exports